<template>
    <div>

        <rkm-area
            title="Cotas cadastradas"
        >
            <template v-slot:trailing>
                <rkm-dropdown
                    class="mr-2"
                    color="primary"
                    cols="1"
                    menu-class="auto-scroll"
                    no-caret
                    small
                    title="Colunas"
                    v-rkm-tooltip.hover
                >
                    <template v-slot:button-content>
                        <rkm-icon icon="columns" />
                    </template>

                    <rkm-form-checkbox
                        :indeterminate="indeterminate"
                        @change="handleTodosClick"
                        class="mx-2"
                        v-model="selectedAll"
                    >
                        Todas
                    </rkm-form-checkbox>

                    <rkm-form-checkbox-group
                        :options="optionalColumns"
                        class="mx-2"
                        stacked
                        text-field="label"
                        v-model="selectedColumns"
                        value-field="key"
                    />
                </rkm-dropdown>
            </template>

            <rkm-table
                :fields="fields"
                :items="dados"
                sort-by="unidadeSolicitante"
                ref="Table"
                hide-filters
                responsive
            >

                <template v-slot:cell(cota)="{ item }">
                    {{ formatQuantidade(item) }}
                </template>

                <template v-slot:cell(utilizada)="{ item }">
                    {{ getUtilizada(item) }}
                </template>

                <template v-slot:cell(saldo)="{ item }">
                    {{ getSaldo(item) }}
                </template>

                <template v-slot:cell(actions)="{ item }">

                    <rkm-button
                        @click="$refs.Modal.open(item)"
                        class="colorButton"
                        small
                        title="Detalhamento"
                    >
                        <rkm-icon icon="search" />
                    </rkm-button>

                    <rkm-button
                        @click.stop="$emit('handleAlter', item)"
                        color="primary"
                        small
                        title="Editar"
                    >
                        <rkm-icon icon="pen" />
                    </rkm-button>

                    <rkm-button
                        color="danger"
                        title="Excluir"
                        small
                        @click.stop="handleCota(item)"
                    >
                        <rkm-icon icon="trash" />
                    </rkm-button>
                </template>

                <template v-slot:cell(transferencia)="{ item }">
                    <span v-if="cotaTipoId == enums.tipoCota.QUANTIDADE">{{ formatMoney(item.transferencia, 0) }}</span>
                    <span v-else>{{ formatMoney(item.transferencia, 2) }}</span>
                </template>

                <template v-slot:cell(transferenciaRecebida)="{ item }">
                    <span v-if="cotaTipoId == enums.tipoCota.QUANTIDADE">{{ formatMoney(item.transferenciaRecebida, 0) }}</span>
                    <span v-else>{{ formatMoney(item.transferenciaRecebida, 2) }}</span>
                </template>

                <template v-slot:custom-foot>
                <rkm-tr>

                    <rkm-th class="table-td" colspan="2">
                        Total
                    </rkm-th>

                    <rkm-th class="table-td text-center" v-if="cotaTipoId == enums.tipoCota.QUANTIDADE">
                        {{ formatMoney(Number(unidadeSolicitantesum), 0)  }}
                    </rkm-th>

                    <rkm-th class="table-td text-center" v-if="cotaTipoId == enums.tipoCota.VALOR">
                        {{ formatMoney(unidadeSolicitantesum, 2) }}
                    </rkm-th>

                    <rkm-th class="table-td text-center" v-if="cotaTipoId == enums.tipoCota.QUANTIDADE && showTotalTransferencia">
                        {{ formatMoney(Number(totalTransferenciaEnviadas), 0)  }}
                    </rkm-th>

                    <rkm-th class="table-td text-center" v-if="cotaTipoId == enums.tipoCota.QUANTIDADE && showTotalTransferenciaRecebida">
                        {{ formatMoney(Number(totalTransferenciaRecebida), 0)  }}
                    </rkm-th>

                    <rkm-th class="table-td text-center" v-if="cotaTipoId == enums.tipoCota.VALOR && showTotalTransferencia">
                        {{ formatMoney(totalTransferenciaEnviadas, 2) }}
                    </rkm-th>

                    <rkm-th class="table-td text-center" v-if="cotaTipoId == enums.tipoCota.VALOR && showTotalTransferenciaRecebida">
                        {{ formatMoney(totalTransferenciaRecebida, 2) }}
                    </rkm-th>

                    <rkm-th class="table-td text-center" v-if="showTotalUtilizada">
                        {{ getUtilizadaTotal() }}
                    </rkm-th>

                    <rkm-th class="table-td text-center">
                        {{ getSaldoTotal() }}
                    </rkm-th>

                    <rkm-th class="table-td"></rkm-th>
                </rkm-tr>
                </template>
            </rkm-table>
        </rkm-area>

        <Modal
            :data="data"
            :unidadeId="unidadeId"
            :itemCota="item"
            :infraestruturaId="infraestruturaId"
            ref="Modal"
        />
    </div>
</template>

<script>

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, object, data, formats } from '@/mixins'

// Enums.
import tipoCota from '@/enums/exame-laboratorial/tipoCota'
import tipoUnidade from '@/enums/exame-laboratorial/tipoUnidade'

// Moment.
import moment from 'moment'

//Components.
import Modal from './transferencia/Modal'

export default {
    components: { Modal },
    computed: {
        fields() {
            return this.columns.filter(column => (column.fixed || false) || this.selectedColumns.includes(column.key))
        },
        optionalColumns() {
            return this.columns.filter(column => !(column.fixed || false))
        },
        showTotalTransferencia() {
            return !!this.selectedColumns.find(c => c === 'transferencia')
        },
        showTotalTransferenciaRecebida() {
            return !!this.selectedColumns.find(c => c === 'transferenciaRecebida')
        },
        showTotalUtilizada() {
            return !!this.selectedColumns.find(c => c === 'utilizada')
        },
        dados() {

            let totalTransferenciaEnviadas = 0
            let totalTransferenciaRecebida = 0

            let filterItems = this.unidadeSolicitante.map(unidade => {

                const cota = this.data.model.cotasTransferencia.find((obj =>
                    obj.laboratorioUnidadeId == this.unidadeId
                    && obj.laboratorioInfraestruturaId == this.infraestruturaId
                    && obj.origemUnidadeId == unidade.unidadeSolicitanteId
                    && obj.origemInfraestruturaId == unidade.infraestruturaSolicitanteId
                ));

                let transferencia = 0
                let transferenciaRecebida = 0

                if (cota) {

                    let cotaTransferencia = cota.destino.filter(i => { return i.origemCotaTipoId == this.cotaTipoId
                        && moment(
                                this.item.periodo.start.split("/").reverse().join("-")
                            )
                            .isBetween(
                                i.origemInicio.split("/").reverse().join("-"),
                                i.origemFim.split("/").reverse().join("-"),
                                null,
                                '[]'
                            )

                        || i.origemCotaTipoId == this.cotaTipoId
                            && moment(
                                this.item.periodo.end.split("/").reverse().join("-")
                            )
                            .isBetween(
                                i.origemInicio.split("/").reverse().join("-"),
                                i.origemFim.split("/").reverse().join("-"),
                                null,
                                '[]'
                            )
                    })

                    let valorUnidade = cotaTransferencia.filter(field => field.origemCotaTipoId == this.enums.tipoCota.VALOR)
                                .reduce((sum, element) => sum + this.formatSumMoney(element.destinoCotaValor), 0);

                    let quantidadeUnidade =  cotaTransferencia.filter(field => field.origemCotaTipoId == this.enums.tipoCota.QUANTIDADE)
                        .reduce((sum, element) => {

                            if (element.destinoCotaQuantidade) {
                                sum = sum + Number(element.destinoCotaQuantidade);
                            }

                            return sum;
                        },0)

                        cotaTransferencia.map(exame => {

                            let cotaExameQuantidade = exame.exames.reduce((sum, element) => {

                                if (element.transferido && element.cotaQuantidadeTransferido) {
                                    sum = sum + Number(element.transferido);
                                }

                                return sum;
                            },0)

                            quantidadeUnidade = quantidadeUnidade + cotaExameQuantidade

                            let cotaExameValor = exame.exames.filter(field => field.cotaValorTransferido > '0,00')
                                .reduce((sum, element) => sum + this.formatSumMoney(element.transferido), 0);

                            valorUnidade = this.formatMoney(valorUnidade, 2)
                            cotaExameValor = this.formatMoney(cotaExameValor, 2)

                            valorUnidade = this.formatSumMoney(valorUnidade) + this.formatSumMoney(cotaExameValor)

                        })

                        if (this.cotaTipoId == this.enums.tipoCota.VALOR) {

                            transferencia = valorUnidade
                        } else {

                            transferencia = quantidadeUnidade
                        }

                        totalTransferenciaEnviadas = totalTransferenciaEnviadas + transferencia

                }

                this.totalTransferenciaEnviadas = totalTransferenciaEnviadas

                let transferenciaLaboratorio = this.data.model.cotasTransferencia.filter(field =>
                    field.unidadeTipoId == this.enums.tipoUnidade.LABORATORIO
                    && field.laboratorioUnidadeId == this.unidadeId
                    && field.laboratorioInfraestruturaId == this.infraestruturaId
                )

                if (transferenciaLaboratorio.length > 0) {

                    transferenciaLaboratorio = transferenciaLaboratorio.map(field2 => field2.destino)

                    Object.keys(transferenciaLaboratorio).forEach(a => {

                        let recebidos = transferenciaLaboratorio[a]
                            .filter(i => i.destinoUnidadeId == unidade.unidadeSolicitanteId
                                && i.destinoInfraestruturaId == unidade.infraestruturaSolicitanteId
                                && i.origemCotaTipoId == this.cotaTipoId
                                && moment(
                                    this.item.periodo.start.split("/").reverse().join("-")
                                )
                                .isBetween(
                                    i.destinoInicio.split("/").reverse().join("-"),
                                    i.destinoFim.split("/").reverse().join("-"),
                                    null,
                                    '[]'
                                )

                                || i.destinoUnidadeId == unidade.unidadeSolicitanteId
                                    && i.destinoInfraestruturaId == unidade.infraestruturaSolicitanteId
                                    && i.origemCotaTipoId == this.cotaTipoId
                                    && moment(
                                         this.item.periodo.end.split("/").reverse().join("-")
                                    )
                                    .isBetween(
                                        i.destinoInicio.split("/").reverse().join("-"),
                                        i.destinoFim.split("/").reverse().join("-"),
                                        null,
                                        '[]'
                                    )
                            )

                        recebidos.forEach(v => {

                            if (this.cotaTipoId == this.enums.tipoCota.VALOR) {

                                transferenciaRecebida = this.formatMoney(transferenciaRecebida, 2)

                                transferenciaRecebida = this.formatSumMoney(transferenciaRecebida) +
                                    this.formatSumMoney(this.getCotaExame(v))

                                transferenciaRecebida = this.formatMoney(transferenciaRecebida, 2)

                            } else {

                                transferenciaRecebida = transferenciaRecebida + this.getCotaExame(v)
                            }
                        });
                    })

                    if (this.cotaTipoId == this.enums.tipoCota.VALOR) {

                        totalTransferenciaRecebida = this.formatMoney(totalTransferenciaRecebida, 2)
                        transferenciaRecebida = this.formatMoney(transferenciaRecebida, 2)

                        totalTransferenciaRecebida = this.formatSumMoney(totalTransferenciaRecebida) +
                                this.formatSumMoney(transferenciaRecebida)
                    } else {

                        totalTransferenciaRecebida = totalTransferenciaRecebida + transferenciaRecebida
                    }

                    this.totalTransferenciaRecebida = totalTransferenciaRecebida
                }

                return {
                    cota: unidade.cota,
                    cotaId: unidade.cotaId,
                    cotaIdUnidadeSolicitante: unidade.cotaIdUnidadeSolicitante,
                    cotaQuantidade: unidade.cotaQuantidade,
                    cotaValor: unidade.cotaValor,
                    transferencia: transferencia,
                    transferenciaRecebida: transferenciaRecebida,
                    id: unidade.id,
                    infraestruturaNome: unidade.infraestruturaNome,
                    infraestruturaSolicitanteId: unidade.infraestruturaSolicitanteId,
                    saldo: unidade.saldo,
                    unidadeSolicitante: unidade.unidadeSolicitante,
                    unidadeSolicitanteId: unidade.unidadeSolicitanteId,
                    valorUtilizado: unidade.valorUtilizado,
                    quantidadeUtilizada: unidade.quantidadeUtilizada,
                }
            })

            return filterItems
        }
    },
    created() {

        this.repositories = {
            saldo: this.getConectaSusRepository('exameLaboratorial.parametrizacao')
        }
    },
    data: () => ({
        items: [],
        model: {
            cotaValor: 0,
            saldo: 0,
            consumido: 0,
            transferencia: 0,
        },
        enums: {
            tipoCota,
            tipoUnidade
        },
        totalTransferenciaEnviadas: 0,
        totalTransferenciaRecebida: 0,
        selectedAll: false,
        indeterminate: false,
        columns: [
            { key: 'unidadeSolicitante', label: 'Unidade solicitante', fixed: true, sortable: true },
            { key: 'infraestruturaNome', label: 'Local de atendimento', fixed: true, sortable: true },
            { key: 'cota', label: 'Cota', class: 'text-center', fixed: true, sortable: true },
            { key: 'transferencia', label: 'Transferência enviada', class: 'text-center', sortable: true },
            { key: 'transferenciaRecebida', label: 'Transferência recebida', class: 'text-center', sortable: true },
            { key: 'utilizada', label: 'Utilizada', class: 'text-center', sortable: true },
            { key: 'saldo', label: 'Saldo', class: 'text-center', fixed: true, sortable: true },
            { key: 'actions', label: 'Ações', class: 'col-min', fixed: true },
        ],
        selectedColumns: [],
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handleTodosClick(selected) {
            this.selectedColumns = selected ? this.optionalColumns.map(c => c.key) : []
        },
        handleCota(item) {

            this.setLoading()

            this.repositories.saldo.saldoUnidadeSolicitante({
                unidade_id: this.unidadeId,
                infraestrutura_id: this.infraestruturaId,
                inicio: this.item.periodo.start.split("/").reverse().join("-"),
                fim: this.item.periodo.end.split("/").reverse().join("-"),
                solicitante_infraestrutura_id: item.infraestruturaSolicitanteId,
                cota_tipo_id: item.origemCotaTipoId,
            })
                .then(response => {

                    this.getCotaUtilizada(response.data, item)

                    if (this.utilizadas == 0 || this.utilizadas == '0,00') {

                        this.handleDestroy(item)
                    } else {

                        this.showValidationNotification(`Não é possível excluir a unidade
                            <strong>${ item.unidadeSolicitante }</strong> e o local de atendimento
                            <strong>${ item.infraestruturaNome }</strong>, pois já possui agendamentos vinculados.`)

                        return false
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getCotaUtilizada(items, item) {

            if (item.origemCotaTipoId == this.enums.tipoCota.VALOR) {

                this.utilizadas = this.formatMoney(parseFloat(items.valorAgendado), 2)
            } else {

                this.utilizadas = items.quantidadeAgendada
            }
        },
        handleDestroy(item) {

            if (item.transferencia > 0 || item.transferencia > "0,00"
                || item.transferenciaRecebida > 0 || item.transferenciaRecebida > "0,00") {

                this.showValidationNotification(`Não é possível excluir a cota, existem transferências relacionadas.`)

                return false
            }

            const objId = this.unidadeSolicitante.findIndex((obj =>
                obj.unidadeSolicitanteId == item.unidadeSolicitanteId
                && obj.infraestruturaSolicitanteId == item.infraestruturaSolicitanteId));

            const destroy = async () => {

                this.unidadeSolicitante.splice(objId, 1)

                this.$emit('checkSum')
            }

            this.showDeleteConfirmation(`Deseja realmente excluir a cota para a unidade solicitante
                <strong>${ item.unidadeSolicitante }</strong> e o local de atendimento
                <strong>${ item.infraestruturaNome }</strong>?`,
                destroy)
        },
        getStringUnidade(item) {

            return `${item.unidadeSolicitante} - ${item.infraestruturaNome}`
        },
        getTransferencia(item) {

            let formatTransferencia = this.formatMoney(item.transferencia, 2)
            let formatTransferenciaRecebida = this.formatMoney(item.transferenciaRecebida, 2)

            formatTransferencia = this.formatSumMoney(item.cota) - this.formatSumMoney(formatTransferencia)
            formatTransferencia = formatTransferencia + this.formatSumMoney(formatTransferenciaRecebida)
            formatTransferencia = this.formatMoney(formatTransferencia, 2)

            return formatTransferencia
        },
        getTransferenciaEnviadas() {

            let formatTotalTranferenciaEnviadas = this.formatMoney(this.totalTransferenciaEnviadas, 2)
            let formatUnidadeSolicitantesum = this.formatMoney(this.unidadeSolicitantesum, 2)
            let totalTransferenciaRecebidas = this.formatMoney(this.totalTransferenciaRecebida, 2)

            formatTotalTranferenciaEnviadas = this.formatSumMoney(formatUnidadeSolicitantesum) -
                this.formatSumMoney(formatTotalTranferenciaEnviadas)

            formatTotalTranferenciaEnviadas = formatTotalTranferenciaEnviadas +
                this.formatSumMoney(totalTransferenciaRecebidas)

            formatTotalTranferenciaEnviadas = this.formatMoney(formatTotalTranferenciaEnviadas, 2)

            return formatTotalTranferenciaEnviadas
        },
        getCotaExame(item) {

            let cotaExame = 0

            if (item.origemCotaTipoId == this.enums.tipoCota.VALOR) {

                 cotaExame = item.exames.reduce((sum, element) => {

                    if (element.transferido) {
                        sum = sum + this.formatSumMoney(element.transferido);
                    }

                    return sum;
                },0)

                if (cotaExame) {

                    cotaExame = this.formatMoney(cotaExame, 2)

                    let destinoCotaValor = this.formatMoney(item.destinoCotaValor, 2)
                    let cotaTotal = this.formatSumMoney(destinoCotaValor) + this.formatSumMoney(cotaExame)

                    return this.formatMoney(cotaTotal, 2)

                } else {

                    return item.destinoCotaValor
                }

            } else {

                cotaExame = item.exames.reduce((sum, element) => {

                    if (element.transferido) {
                        sum = sum + Number(element.transferido);
                    }

                    return sum;
                },0)

                return Number(item.destinoCotaQuantidade) + cotaExame
            }
        },
        getUtilizada(item) {

            if (this.cotaTipoId == this.enums.tipoCota.VALOR) {

                return item.valorUtilizado
            } else {

                return this.formatMoney(item.quantidadeUtilizada, 0)
            }
        },
        getSaldo(item) {

            if (this.cotaTipoId == this.enums.tipoCota.VALOR) {

                let cota = this.formatMoney(item.cota, 2)
                let transferencia = this.formatMoney(item.transferencia, 2)
                let transferenciaRecebida = this.formatMoney(item.transferenciaRecebida, 2)
                let valorUtilizado = this.formatSumMoney(item.valorUtilizado)

                const saldo = ((this.formatSumMoney(cota) - valorUtilizado) - this.formatSumMoney(transferencia)) + this.formatSumMoney(transferenciaRecebida)

                return this.formatMoney(parseFloat(saldo), 2)
            } else {

                const saldo = ((item.cota - Number(item.quantidadeUtilizada)) - item.transferencia) + item.transferenciaRecebida

                return this.formatMoney(saldo, 0)
            }
        },
        getUtilizadaTotal() {

            if (this.cotaTipoId == this.enums.tipoCota.VALOR) {

                let saldo = this.unidadeSolicitante.reduce((sum, element) => {

                    if (element.valorUtilizado) {

                        let valorUtilizado = this.formatSumMoney(element.valorUtilizado)

                        sum = sum + valorUtilizado;
                    }

                    return sum;
                },0)

                return this.formatMoney(parseFloat(saldo), 2)
            } else {

                return this.unidadeSolicitante.reduce((sum, element) => {

                    if (element.quantidadeUtilizada) {
                        sum = sum + Number(element.quantidadeUtilizada);
                    }

                    return sum;
                },0)
            }
        },
        getSaldoTotal() {

            if (this.cotaTipoId == this.enums.tipoCota.VALOR) {

                let saldo = this.dados.reduce((sum, element) => {


                        let valorUtilizado = this.getSaldo(element)
                        valorUtilizado = this.formatSumMoney(valorUtilizado)

                        sum = sum + valorUtilizado;

                    return sum;
                },0)

                return this.formatMoney(parseFloat(saldo), 2)
            } else {

                let saldo =  this.dados.reduce((sum, element) => {

                    let quantidadeUtilizada = this.getSaldo(element)
                    quantidadeUtilizada = this.formatSumMoney(quantidadeUtilizada)

                    sum = sum + Number(quantidadeUtilizada);

                    return sum;
                },0)

                return this.formatMoney(saldo, 0)
            }
        },
        formatQuantidade(item) {

            const cota = item.cota
            return this.cotaTipoId == this.enums.tipoCota.VALOR ? cota : this.formatMoney(Number(cota), 0)
        },
        formatTransferencia(item) {

            const transferencia = item.transferencia
            return item.cotaTipoId == this.enums.tipoCota.VALOR ? transferencia : this.formatMoney(Number(transferencia), 0)
        },
        formatTransferenciaRecebida(item) {

            const transferenciaRecebida = item.transferenciaRecebida
            return item.cotaTipoId == this.enums.tipoCota.VALOR
                ? transferenciaRecebida : this.formatMoney(Number(transferenciaRecebida), 0)
        }
    },
    props: {
        data: { type: Object, required: true },
        item: { type: Object, required: true },
        unidadeSolicitante: { type: Array, required: true },
        unidadeSolicitantesum: { type: Number, required: true },
        cotaTipoId: { type: Number, required: true },
        indexLaboratorio: { type: [Number, String], required: true },
        unidadeId: { type: Number, default: null },
        infraestruturaId: { type: Number, default: null },
    },
    mixins: [repository, object, data, formats],
    watch: {
        selectedColumns(value) {
            this.indeterminate = value.length > 0 && value.length != this.optionalColumns.length
            this.selectedAll = value.length > 0 && value.length == this.optionalColumns.length
        },
    }
}
</script>

<style scoped>
.table-td {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    border-top: 1px solid #ccc;
    font-weight: 600;
}
.table-border-top {
    border-top: 0;
    height: 30px;
    padding: 0;
}
.table-width {
    width: 100%;
}

</style>